// extracted by mini-css-extract-plugin
export default {"iconExpanded":"src-components-Select-SbSelect__iconExpanded--uCtVR","select":"src-components-Select-SbSelect__select--FpynV"};